import HttpCliente from "../servicios/HttpCliente";

// Endpoint para Campo de busqueda por numero de contrato
export const obtenerBusquedaContrato = async (ncontrato) => {
    return await HttpCliente.get(`/Contratos/${ncontrato}`);
};

export const obtenerTodosContratos = async (operacion) => {
    const url = `/Contratos/Operacion/${operacion}`;
    return await HttpCliente.get(url);
};

export const obtenerOperaciones = async () => {
    return await HttpCliente.get(`/Parametros/CentroCosto`);
}; 

export const obtenerGerenciaGeneral = async (operacion) => {
    return await HttpCliente.get(`/Parametros/CentroCosto?operacion=${operacion}`);
}; 

export const obtenerGerencia = async (operacion, gerenciaGeneral) => {
    return await HttpCliente.get(`/Parametros/CentroCosto?operacion=${operacion}&gerenciageneral=${gerenciaGeneral}`);
}; 

export const obtenerSuperIntendencia = async (operacion, gerenciaGeneral, gerencia ) => {
    return await HttpCliente.get(`/Parametros/CentroCosto?operacion=${operacion}&gerenciageneral=${gerenciaGeneral}&gerencia=${gerencia}`);
}; 

export const obtenerArea = async (operacion, gerenciaGeneral, gerencia, superintendencia) => {
    return await HttpCliente.get(`/Parametros/CentroCosto?operacion=${operacion}&gerenciageneral=${gerenciaGeneral}&gerencia=${gerencia}&superintendencia=${superintendencia}`);
};

export const obtenerCentroCosto = async (operacion, gerenciaGeneral, gerencia, superintendencia, area ) => {
    return await HttpCliente.get(`/Parametros/CentroCosto?operacion=${operacion}&gerenciageneral=${gerenciaGeneral}&gerencia=${gerencia}&superintendencia=${superintendencia}&area=${area}`);
}; 

export const obtenerOperacion_ModalUsuarioContrato = async () => {
    return await HttpCliente.get("/Operaciones");
}; 

export const obtenerlistadoCentrosDeCosto = async (idcontrato, idOperacion) => {
    return await HttpCliente.get(`/Contratos/CentroCostoContrato/${idcontrato}/${idOperacion}`);
}; 

export const obtenerOperacionUnidadOrg = async () => {
    return await HttpCliente.get(`/UnidadesOrganizacionales`);
};

export const insertarDatosDuenaContrato = async (payload) => {
    return await HttpCliente.post(`/Contratos/UnidadOrganizacionalContrato/`, payload);
}; 

export const insertarDatosUsuariaContrato = async (payload) => {
    return await HttpCliente.post("/Contratos/CentroCostoContrato/", payload);
}; 

/* export const insertarDatosUsuariaContrato = async (idcontrato, idcentrocosto) => {
    return await HttpCliente.post(`/Contratos/CentroCostoContrato/${idcontrato}/${idcentrocosto}`);
}; */ 
